import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Heading } from "@/components/ui/heading";
import { Text } from "@/components/ui/text";
import PunchCardLogo from "../logos/PunchCardLogo";
import SignUp from "../SignUp";
import { User } from "../../modules/users/types";
import AnimatedBackground from "../AnimatedBackground";
import Container from "../Container";

interface SignUpPageProps {
  onSignUpSuccess: (user: User) => void;
}

const SignUpPage: React.FunctionComponent<SignUpPageProps> = ({
  onSignUpSuccess,
}) => {
  const [error, setError] = useState<string | null>(null);

  const handleError = (errorMessage: string) => {
    setError(errorMessage);
  };

  const handleSignUpSuccess = (user: User) => {
    setError(null);
    onSignUpSuccess(user);
  };

  return (
    <AnimatedBackground>
      <Container>
        <div className="w-full max-w-md">
          <Card className="shadow-xl bg-card/95 backdrop-blur-sm">
            <CardHeader className="items-center">
              <PunchCardLogo type="icon" />
            </CardHeader>
            <CardContent>
              {error && (
                <div className="bg-destructive/10 border border-destructive/40 px-4 py-3 rounded mb-4">
                  <Text variant="sm" className="text-destructive">{error}</Text>
                </div>
              )}

              <Heading level={1} variant="sm" className="mb-6">Sign Up</Heading>

              <SignUp onSuccess={handleSignUpSuccess} onError={handleError} />
            </CardContent>
            <CardFooter className="border-t justify-center">
              <Text variant="sm" className="text-muted-foreground">
                Already have an account?{" "}
                <Link to="/sign-in" className="text-primary hover:underline">
                  Sign in
                </Link>
              </Text>
            </CardFooter>
          </Card>
        </div>
      </Container>
    </AnimatedBackground>
  );
};

export default SignUpPage;
